export function setAvailableCardList(chargeData) {
  var cardList = {};
  var arr: any = [];
  for (const card of chargeData.availableCardBrandList) {
    switch (card) {
      case "Visa":
        arr.push("/images/Visa_Brandmark_Blue_RGB_2021.png");
        break;
      case "MasterCard":
        arr.push("/images/mastercard_logo.jpg");
        break;
      case "JCB":
        arr.push("/images/jcb-logomark-img-03.gif");
        break;
      case "American Express":
        arr.push("/images/amex-logomark-img-06.gif");
        break;
      case "Diners Club":
        arr.push("/images/diners_logo_white.gif");
        break;
      case "Discover":
        arr.push("/images/discover-logomark-img-06.gif");
        break;
      default:
        break;
    }
  }
  cardList["cardImages"] = arr;
  cardList["cardNames"] = chargeData.availableCardBrandList;
  return cardList;
}
